import React from 'react';
import { toast } from 'react-toastify';
import SubLayout from '../../components/Layout/SubLayout'
import strings from '../../components/Language';
import "./profile.scss"

import ArrowForword from './../../assets/images/icons/arrow_forword.svg';

import AccountProblem from './../../assets/images/icons/account_problem.svg';
import Trend from './../../assets/images/icons/trend.svg';
import Bulb from './../../assets/images/icons/bulb.svg';
import ReportViolation from './../../assets/images/icons/report_violation.svg';
import MoneyFlow from './../../assets/images/icons/money_flow.svg';
import ApiBind from './../../assets/images/icons/api_bind.svg';
import Bug from './../../assets/images/icons/bug.svg';
import More from './../../assets/images/icons/more.svg';

class HelpLineScreen extends React.Component {

	comingSoon() {
		toast.warning(strings.Coming_Soon);
	}

	render() {
		const helpItems = [
			{ key: 'account', icon: AccountProblem, label: strings.account_problem },
			{ key: 'trading', icon: Trend, label: strings.trading_problem },
			{ key: 'suggestion', icon: Bulb, label: strings.suggestion_opinions },
			{ key: 'violation', icon: ReportViolation, label: strings.report_violation },
			{ key: 'money', icon: MoneyFlow, label: strings.money_flow_problem },
			{ key: 'api', icon: ApiBind, label: strings.api_binding_issues },
			{ key: 'bug', icon: Bug, label: strings.bug_problem },
			{ key: 'other', icon: More, label: strings.other },
		];

		return (
			<SubLayout data={{ "title": strings.helpline }}>
				<div className="profile-subpage">
					<div className='profile-panel'>
						{helpItems.map((item) => (
							<div key={item.key} onClick={() => this.comingSoon()} className='profile-list-item' style={{ cursor: 'pointer' }}>
								<div className='profile-list-left'>
									<img src={item.icon} alt={item.label} width={25} height={25}></img>
									<span>{item.label}</span>
								</div>
								<div className='profile-list-right'>
									<img src={ArrowForword} alt="ArrowForword"></img>
								</div>
							</div>
						))}
					</div>
				</div>
			</SubLayout >
		);
	}
}

export default HelpLineScreen;
